import * as Sentry from '@sentry/react';

// VITE_SENTRY_DSN is required to send events
const initSentry = () => {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: import.meta.env.VITE_SENTRY_RELEASE ?? '',
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'development',

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,

    integrations: [Sentry.browserTracingIntegration()],
  });
};

export default initSentry;
